import React from 'react'
import { twMerge } from 'tailwind-merge'

export const LayoutSwitcherButton = ({
  active,
  onClick,
  children,
  className,
}: {
  active: boolean
  onClick: () => void
  children: React.ReactNode
  className?: string
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(
        'grid basis-1/2 justify-center gap-x-0.5 gap-y-1',
        'rounded-lg border border-border200 bg-bgPrimaryBase p-3',
        'cursor-pointer outline-0.5 outline-inputBorderInteractive hover:outline-solid',
        active && 'outline-solid',
        className,
      )}
    >
      {children}
    </button>
  )
}
